import { styled } from "@vitality-ds/system";
import { components } from "react-select";
import BaseClearButtonStyles from "./styles/BaseClearButton.styles";
var ClearIndicator = components.ClearIndicator;

// eslint-disable-next-line import/prefer-default-export
export var BaseClearButton = styled(ClearIndicator, BaseClearButtonStyles);